<template>
  <div class="ww dwp dbt" style="margin-top: 30px;">
    <div
      v-for="item in purchaseList.list"
      :key="item.buy_code"
      class="card dlbt"
      style="width:289px; height:203px;background-color:white;border-radius:8px; margin-bottom:20px; overflow:hidden;cursor: pointer; "
      @click="$emit('detail', item)"
    >
      <div
        class="dy"
        style="min-height:38px; border-bottom:1px solid #eee;padding-left: 20px;color:#999; font-size:14px;"
      >
        {{ item.created_at | dateFilter }}
      </div>
      <div style="padding-left: 20px;height:100%;">
        <div style="line-height:30px;">{{ item.title }}</div>
        <div class="dybottom">
          <div
            style="color:red;font-size:20px;font-weight:700; margin-right:5px;"
          >
            面议
          </div>
          <div style="font-size:14px; color:red;font-weight:600;">求购中</div>
        </div>
        <div
          style="font-size: 12px; color: #999; line-height: 20px;  max-height: 40px;overflow: hidden; margin-top:5px;"
        >
          需求描述: {{ item.describe }}
        </div>
      </div>
      <div
        class="dy dbt"
        style="min-height:48px;padding-left: 20px; background-color:#fffbf8;color: #999;font-size: 12px;"
      >
        <div class="ds">
          <div
            style="padding-right:10px;border-right: 1px solid #e6e6e6; margin-right:10px;"
          >
            {{ item.province_name ? item.province_name : region_name }}
          </div>
          <div>{{item.contact_name}}</div>
        </div>

        <div style=""></div>
      </div>
    </div>
    <div
      v-for="item in 4 - (arr.length % 4)"
      :key="item"
      style="width:289px; height:203px;background-color:white;border-radius:8px; margin-bottom:20px;visibility: hidden;"
    ></div>
  </div>
</template>
<script>
export default {
  name: "PurchaseList",
  props: {
    purchaseList: Object,
  },
  data() {
    return {
      arr: [],
    };
  },
  created() {},
  filters: {
    dateFilter(e) {
      function getDateDiff(dateTimeStamp) {
        var minute = 1000 * 60;
        var hour = minute * 60;
        var day = hour * 24;
        // var halfamonth = day * 15;
        var month = day * 30;
        var now = new Date().getTime();
        var diffValue = now - dateTimeStamp;
        if (diffValue < 0) {
          return;
        }
        var monthC = diffValue / month;
        var weekC = diffValue / (7 * day);
        var dayC = diffValue / day;
        var hourC = diffValue / hour;
        var minC = diffValue / minute;
        let result = ""
        if (monthC >= 1) {
          result = "" + parseInt(monthC) + "月前";
        } else if (weekC >= 1) {
          result = "" + parseInt(weekC) + "周前";
        } else if (dayC >= 1) {
          result = "" + parseInt(dayC) + "天前";
        } else if (hourC >= 1) {
          result = "" + parseInt(hourC) + "小时前";
        } else if (minC >= 1) {
          result = "" + parseInt(minC) + "分钟前";
        } else result = "刚刚";
        return result;
      }
      //转换标准时间为时间戳：
      function getDateTimeStamp(dateStr) {
        return Date.parse(dateStr.replace(/-/gi, "/"));
      }
      return getDateDiff(getDateTimeStamp(e)) ;
    },
  },
};
</script>
<style scoped>
.card:hover {
  box-shadow: 0 3px 2px rgb(0 0 0 / 3%);
}
</style>
